<template>
  <div :class="['v-avatar', avatarVariant, avatarSize]">
    <template v-if="logoFallback">
      <div class="v-avatar-fallback">
        <img
          src="../../assets/images/logo-videomedi-white-symbol.png"
          alt="specialista"
        />
      </div>
    </template>
    <template v-else>
      <span v-if="text && !src">{{ text }}</span>
      <img v-if="src" :src="src" />
    </template>
  </div>
</template>

<script>
const variants = Object.freeze({
  PRIMARY: "primary",
  LIGHT: "light"
});

const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XXL: "xxl"
});

export default {
  name: "BaseAvatar",
  props: {
    variant: {
      type: String,
      validator: value => Object.values(variants).includes(value),
      required: false,
      default: variants.PRIMARY
    },
    text: {
      type: String,
      required: false,
      default: ""
    },
    src: {
      type: String,
      required: false,
      default: ""
    },
    logoFallback: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      required: true,
      default: sizes.MD
    }
  },
  computed: {
    avatarVariant() {
      return this.src ? "" : `v-avatar-${this.variant}`;
    },
    avatarSize() {
      return `v-avatar-${this.size}`;
    }
  }
};
</script>
